import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

function Navbar() {
  const [settings, setSettings] = useState(null);
  const [menu, setMenu] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [settingsRes, menuRes] = await Promise.all([
        axiosInstance.get("/api/settings"),
        axiosInstance.get("/api/menu"),
      ]);
      setSettings(settingsRes.data);
      setMenu(menuRes.data);
    } catch (err) {
      console.error("Failed to load navbar data", err);
    }
  };

  const resolveLink = (item) => {
    if (item.link_type === "page") return `/pages/${item.link_value}`;
    if (item.link_type === "external") return item.link_value;
    return `/${item.link_value}`; // module — e.g. /gallery, /facilities
  };

  const handleClick = (item, e) => {
    if (item.link_type === "external") return; // let default <a> behavior happen
    e.preventDefault();
    navigate(resolveLink(item));
  };

  const logoUrl = settings?.logo_path
    ? `${process.env.REACT_APP_API_URL}/${settings.logo_path}`
    : null;

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top py-2"
      style={{
        borderBottom: `3px solid ${settings?.theme_primary_color || "#0d6efd"}`,
      }}
    >
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={settings?.school_name}
              style={{ height: "42px" }}
            />
          ) : (
            <i className="bi bi-mortarboard-fill fs-3 text-primary"></i>
          )}
          <div>
            <div
              className="fw-bold"
              style={{ fontSize: "1.05rem", lineHeight: 1.1 }}
            >
              {settings?.school_name || "School Name"}
            </div>
            {settings?.tagline && (
              <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                {settings.tagline}
              </div>
            )}
          </div>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ms-auto">
            {menu.map((item) => (
              <li className="nav-item dropdown" key={item.id}>
                {item.children?.length > 0 ? (
                  <>
                    <a
                      className="nav-link dropdown-toggle"
                      href={resolveLink(item)}
                      role="button"
                      data-bs-toggle="dropdown"
                      onClick={(e) => handleClick(item, e)}
                    >
                      {item.label}
                    </a>
                    <ul className="dropdown-menu">
                      {item.children.map((child) => (
                        <li key={child.id}>
                          <a
                            className="dropdown-item"
                            href={resolveLink(child)}
                            target={child.open_new_tab ? "_blank" : undefined}
                            rel={
                              child.open_new_tab
                                ? "noopener noreferrer"
                                : undefined
                            }
                            onClick={(e) => handleClick(child, e)}
                          >
                            {child.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a
                    className="nav-link"
                    href={resolveLink(item)}
                    target={item.open_new_tab ? "_blank" : undefined}
                    rel={item.open_new_tab ? "noopener noreferrer" : undefined}
                    onClick={(e) => handleClick(item, e)}
                  >
                    {item.label}
                  </a>
                )}
              </li>
            ))}
            <li className="nav-item ms-lg-2 mt-2 mt-lg-0">
              <Link to="/contact" className="btn btn-primary btn-sm px-3">
                Enquire Now
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
